import { FC } from 'react'
import { ActionButtonProps } from 'src/components/ActionButton'

import FormikField from '../../form/FormikField'
import { FormikFormProps } from '../../form/FormikForm'
import { ActionButtonVariant } from '../../components/ActionButton/styled'
import { FormSubmitButtonProps } from '../../form/FormSubmitButton'
import FormMessages, { FormMessagesProps } from '../../form/FormMessages'
import { FormFieldEmailProps } from '../../form/fields/FormFieldEmail'
import { FormFieldOrientation } from '../../types/form'

import * as SC from './styled'

type LoginMethodFormValues = {
  email?: string
  password?: string
}

export type LoginMethodFormProps = FormikFormProps<LoginMethodFormValues> & {
  fields: {
    email?: Omit<FormFieldEmailProps, 'name'>
    password?: Omit<FormFieldEmailProps, 'password'>
  }
  innerActions?: {
    submitButton?: FormSubmitButtonProps
  }
  bottomActions?: {
    submitButton?: FormSubmitButtonProps
    forgottenPassword?: ActionButtonProps
  }
  errors?: FormMessagesProps['messages']
}

const LoginMethodForm: FC<LoginMethodFormProps> = ({
  fields,
  innerActions,
  bottomActions,
  errors,
  ...formikProps
}) => {
  const { email, password } = fields

  return (
    <SC.Container>
      <SC.Form {...formikProps}>
        <SC.Fields>
          {email && (
            <FormikField
              labelProps={{ underlined: true }}
              orientation={FormFieldOrientation.Horizontal}
              {...email}
              name="email"
              Component={SC.EmailField}
            />
          )}
          {password && (
            <FormikField
              labelProps={{ underlined: true }}
              orientation={FormFieldOrientation.Horizontal}
              name="password"
              type="password"
              {...password}
              Component={SC.TextField}
            />
          )}
          {innerActions?.submitButton && (
            <SC.SubmitButton
              type={'submit'}
              variant={ActionButtonVariant.quaternary}
              {...innerActions?.submitButton}
            />
          )}
        </SC.Fields>
        {bottomActions && (
          <SC.Actions>
            <SC._ActionButton
              variant={ActionButtonVariant.secondary}
              {...bottomActions.forgottenPassword}
            />
            <SC.SubmitButton
              type={'submit'}
              variant={ActionButtonVariant.quaternary}
              {...bottomActions.submitButton}
            />
          </SC.Actions>
        )}
        {errors && <FormMessages messages={errors} />}
      </SC.Form>
    </SC.Container>
  )
}

export default LoginMethodForm
